import React from 'react';
import { Link } from 'react-router-dom'; // Використовуємо для безпечного внутрішнього роутингу

const NotFoundPage = () => {
    // bg-[#dfcaa7]
    return (
        <div className="min-h-screen bg-[#faf8f5] flex flex-col items-center justify-center px-4 text-center font-sans">
            <div className="max-w-md w-full">

                {/* Анімація або велика іконка */}
                <div className="relative mb-6 flex justify-center items-center">
                    <h1 className="text-9xl font-black text-[#d4a373] opacity-20 select-none tracking-widest">
                        404
                    </h1>
                    <div className="absolute text-6xl animate-bounce">
                        🪡
                    </div>
                </div>

                {/* Тематичний заголовок */}
                <h2 className="text-3xl font-bold text-[#3d3a35] mb-4 tracking-tight">
                    Ой, нитка обірвалася...
                </h2>

                {/* Опис проблеми */}
                <p className="text-[#7a756e] mb-8 leading-relaxed">
                    Схоже, цей стібок повів вас не туди. Сторінки, яку ви шукаєте на <span className="font-semibold text-[#d4a373]">lovestitchua.shop</span>, не існує, або її було перенесено в інше місце.
                </p>

                {/* Навігаційні кнопки */}
                <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-10">
                    <Link
                        to="/"
                        className="w-full sm:w-auto px-6 py-3 bg-[#d4a373] text-white font-medium rounded-lg shadow-sm hover:bg-[#c39262] transition duration-300 ease-in-out"
                    >
                        Повернутися на головну
                    </Link>
                    <Link
                        to="/catalog"
                        className="w-full sm:w-auto px-6 py-3 bg-white text-[#3d3a35] border border-[#e1dbd5] font-medium rounded-lg hover:bg-white hover:border-[#d4a373] transition duration-300 ease-in-out"
                    >
                        Перейти до каталогу
                    </Link>
                </div>

                {/* Корисні посилання для утримання клієнта */}
                <div className="border-t border-[#e6e2dd] pt-6">
                    <p className="text-xs uppercase tracking-wider text-[#9c968e] mb-4">
                        Швидкі посилання
                    </p>
                    <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-[#7a756e]">
                        <Link to="/about" className="hover:text-[#d4a373] transition-colors">Про нас</Link>
                        <Link to="/contacts" className="hover:text-[#d4a373] transition-colors">Контакти</Link>
                        <Link to="/delivery" className="hover:text-[#d4a373] transition-colors">Доставка та оплата</Link>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default NotFoundPage;